var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":_vm.$store.state.alert.toggle,"color":_vm.$store.state.alert.color,"icon":_vm.$store.state.alert.icon,"dismissible":_vm.$store.state.alert.dismissible,"dark":""}},[_c('span',{staticClass:"MontserratMedium",domProps:{"innerHTML":_vm._s(_vm.$store.state.alert.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }